import {useDispatch, useSelector} from "react-redux";
import {auth, AuthState} from "@/store/modules/auth";
import {useFormik} from "formik";
import {BaseInput} from "../input/BaseInput";
import {notification} from "@/store/modules/notification";
import {StoreUtil} from "@/util/store/StoreUtil";
import {CompletePasswordReset, CompletePasswordResetRequestInit} from "@/model/request/auth/CompletePasswordReset.ts";

export default function ChangePasswordForm() {
    const dispatch = useDispatch();
    const authState = useSelector<any>((state) => state.auth) as AuthState;

    const showMessageError = (response: any) => {
        StoreUtil.execute(() =>
            dispatch(
                notification.mutation.openModal({
                    type: "error",
                    title: "Error",
                    body: response.responseMessage,
                })
            )
        );
    };

    const showMessageSuccess = (response: any) => {
        StoreUtil.execute(() => {
                dispatch(
                    notification.mutation.openModal({
                        type: "success",
                        title: "Success",
                        body: response.responseMessage,
                    })
                )
                dispatch(auth.mutation.setTempEmail(""))
            }
        );
    };

    const handleSubmit = async (value: CompletePasswordReset) => {
        const request = {...value, userEmail: authState.tempEmail, otp: authState.otp}
        await dispatch<any>(
            auth.action.resetPassword({
                data: request,
                onSuccess: (response: any) => showMessageSuccess(response),
                onError: (response: any) => showMessageError(response),
            })
        );
    };

    const formik = useFormik({
        onSubmit: handleSubmit,
        initialValues: CompletePasswordResetRequestInit,
        // validationSchema: AuthValidation.changePassword,
    });

    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <div className="form-field-wrapper">
                    <BaseInput
                        formik={formik}
                        style={{paddingLeft: "20px"}}
                        className="form-input login w-input"
                        name="Password"
                        placeholder="Enter New password"
                        type="password"
                    />
                </div>
                {/*<div className="form-field-wrapper">*/}
                {/*    <BaseInput*/}
                {/*        formik={formik}*/}
                {/*        errorStyle={{color: "red"}}*/}
                {/*        style={{paddingLeft: "38px", marginBottom: "0"}}*/}
                {/*        autoComplete={"off"}*/}
                {/*        className="form-input login w-input"*/}
                {/*        maxLength={256}*/}
                {/*        name="userPassword"*/}
                {/*        placeholder="Confirm password"*/}
                {/*        type="password"*/}
                {/*        id="Confirm Password"*/}
                {/*        required*/}
                {/*    />*/}
                {/*</div>*/}
                <div className="w-layout-grid form-button-wrapper">
                    <BaseInput
                        type="submit"
                        formik={formik}
                        value="Proceeed"
                        name={"Change"}
                        loading={authState.loading}
                        className={"button max-width-full login w-button"}
                    />
                </div>
            </form>
        </>
    );
}
